import React, {useEffect, useState} from "react";
import {Alert, InputNumber, Modal, Typography} from "antd";
import api from "@/api/axios.js";

const {Text} = Typography;

/**
 * Rinumerazione manuale di una gabbia in pre-elaborazione.
 *
 * Il seriale è l'identità della gabbia (card, SSE, import varianti, XML): il duplicato nel
 * volantino corrente si controlla qui sullo stato locale (può non essere ancora salvato), il
 * resto della promo e l'assenza di card elaborate li verifica il server, che porta anche il
 * contatore promo oltre il numero scelto. `onConfirm(newSerial)` rinomina la zona in stato.
 */
export default function EditSerialModal({open, flyerId, zone, localSerials, onConfirm, onCancel})
{
	const [value, setValue] = useState(null);
	const [error, setError] = useState("");
	const [saving, setSaving] = useState(false);

	useEffect(() =>
	{
		if (open)
		{
			setValue(zone?.id ?? null);
			setError("");
			setSaving(false);
		}
	}, [open, zone?.id]);

	const handleOk = async () =>
	{
		const serial = Number(value);
		if (!Number.isInteger(serial) || serial < 1)
		{
			setError("Inserisci un numero intero maggiore di zero.");
			return;
		}
		if (serial === zone?.id)
		{
			onCancel?.();
			return;
		}
		if (localSerials?.has(serial))
		{
			setError(`Il seriale #${serial} è già usato da un'altra gabbia di questo volantino.`);
			return;
		}

		setSaving(true);
		try
		{
			const {data} = await api.post(`/api/flyers/${flyerId}/claim-serial`, {serial, fromSerial: zone?.id});
			if (!data?.ok)
			{
				setError(data?.error || "Seriale non disponibile.");
				return;
			}
			onConfirm?.(serial);
		}
		catch (e)
		{
			setError(e?.response?.data?.error || "Impossibile verificare il seriale: riprova.");
		}
		finally
		{
			setSaving(false);
		}
	};

	return (
		<Modal
			open={open}
			title={`Modifica seriale gabbia #${zone?.id ?? ""}`}
			okText="Applica"
			cancelText="Annulla"
			confirmLoading={saving}
			onOk={handleOk}
			onCancel={onCancel}
			destroyOnHidden
		>
			<Text type="secondary">
				Il seriale deve essere unico in tutta la promo. Le gabbie create dopo continueranno la
				numerazione dal numero più alto.
			</Text>
			<InputNumber
				autoFocus
				min={1}
				max={999999}
				precision={0}
				value={value}
				onChange={(v) => { setValue(v); setError(""); }}
				onPressEnter={handleOk}
				style={{width: "100%", marginTop: 12}}
				prefix="#"
			/>
			{error ? <Alert type="error" showIcon message={error} style={{marginTop: 12}}/> : null}
		</Modal>
	);
}
